import React from 'react';
import {Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import setDate from '../../utils/setDate';
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import useStyles from "../../styles/styles";

const ExperimentRecordsShortForm = ({apiRequestId}) => {
    const classes = useStyles();

    const {loading, error, data} = useQuery(gql`
        query Experiments($apiRequestId: UUID!) {
            experiments(apiRequestId: $apiRequestId) {
                id
                createdAt
                experiment
                variant
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const experiments = data?.experiments ?? []

    if (loading) {
        return (
            <>
            </>
        );
    }

    if (!experiments.length || error) {
        return (
            <>
            </>
        );
    }

    return (
        experiments.length ?
            <>
                <Typography variant="h4" component="h4" align="left">Experiments</Typography>
                <Paper className={classes.paper}>
                    <Table className={classes.table} size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell variant="head">Created At</TableCell>
                                <TableCell variant="head">Experiment</TableCell>
                                <TableCell variant="head">Variant</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {experiments.map(experiment => (
                                <TableRow key={experiment.id}>
                                    <TableCell variant="body">{setDate(experiment.createdAt)}</TableCell>
                                    <TableCell variant="body">{experiment.experiment}</TableCell>
                                    <TableCell variant="body">{experiment.variant}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </>
            : null
    );
};

export default ExperimentRecordsShortForm
